import { useState, useEffect } from 'react';
import { Header, ContentContainer } from 'prosci-ui';
import { usePageContext } from '@/contexts/page-context';
import { TestCasesTab } from './test-cases-tab';
import { EvalRunsTab } from './eval-runs-tab';
import { BenchmarksTab } from './benchmarks-tab';

const TABS = [
  { id: 'cases', label: 'Test Cases' },
  { id: 'runs', label: 'Eval Runs' },
  { id: 'benchmarks', label: 'Benchmarks' },
] as const;

type TabId = (typeof TABS)[number]['id'];

export function KaiyaEvalsPage() {
  const { setShowPageHeader } = usePageContext();
  const [activeTab, setActiveTab] = useState<TabId>('cases');

  useEffect(() => {
    setShowPageHeader(false);
    return () => setShowPageHeader(true);
  }, [setShowPageHeader]);

  return (
    <>
      <Header
        title="Kaiya Evaluations"
        description="Test cases, evaluation runs, and quality benchmarks"
      />

      <ContentContainer>
        <div className="border-b mb-6">
          <div className="flex gap-4">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`pb-2 px-1 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {activeTab === 'cases' && <TestCasesTab />}
        {activeTab === 'runs' && <EvalRunsTab />}
        {activeTab === 'benchmarks' && <BenchmarksTab />}
      </ContentContainer>
    </>
  );
}
